import React from 'react';

import { H1 } from '@r1-frontend/ui-react/components/typography/heading';

import LogoYandexStation from '~/static/images/yandex-landing/yandex-station.svg';

import * as ST from './styled';

const HeaderTextBlock: React.FC = () => {

    return (
        <ST.HeaderTextWrapper>
            <ST.H1 as='div'><ST.LogoYandexStation src={LogoYandexStation} title={'Яндекс Станция'} alt={'Яндекс Станция'}/></ST.H1>
            <H1 $withIndent={false}>
                Одна Станция —<br /> много Плюсов
            </H1>
            <ST.HeaderSubtext>
                Выберите Станцию и&nbsp;оформите к&nbsp;ней подписку Яндекс Плюc.
                Пользуйтесь Кинопоиском, Яндекс.Музыкой и&nbsp;кешбэком баллами в&nbsp;сервисах Яндекса.
            </ST.HeaderSubtext>
        </ST.HeaderTextWrapper>
    );
};

export default HeaderTextBlock;
